import React from 'react';
import Services from './Services';
import ServicesChartsDataProvider from '../../../../Common/Services/contexts/ServicesChartsDataContext';
import { subtitlesMap } from '../../maps/subtitleMap';

const ServicesWrapper = ({ queryConfig, module }) => {
    return (
        <ServicesChartsDataProvider
            module={module}
            queryConfig={queryConfig}
            subtitlesMap={subtitlesMap}
        >
            <Services />
        </ServicesChartsDataProvider>
    );
};

export default ServicesWrapper;
